import { useTranslation } from 'react-i18next';
import { Link } from 'react-scroll';

const SkipToMain = ({ bg }: any) => {
    const { t } = useTranslation('common');
    const handleClick = () => {
        const secondButton: any = document.getElementById("skip-page");
        secondButton.click();
    }

    return (
        <div className="h-full px-[5px] mm:px-[8px] lgs:px-[10px] hidden xsm:block">
            <button onClick={handleClick} className="flex items-center justify-center h-full hover:underline focus:underline">
                <Link id="skip-page" to="home" spy={true} smooth={true} className={`${bg ? "text-white" : "text-blackDark"} dark:text-white font-semibold pt-[1px] mm:pt-0 text-[11px] mm:text-[12px] xlx:text-[13px] leading-tight`}>{t("header.skip_main_content")}</Link>
            </button>
        </div>
    );
};

export default SkipToMain;